<script lang="ts" setup>
const router = useRouter()

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  buttonType: {
    type: String as PropType<'refresh' | 'back'>,
    default: 'refresh',
  },
})

const slots = defineSlots<{
  buttons: any
}>()

const computedDescription = computed(() => {
  return props.description ? props.description : ''
})

const buttonTitle = computed(() => {
  return props.buttonType === 'refresh' ? '새로고침' : '뒤로가기'
})

const handleClickSubButton = () => {
  if (props.buttonType === 'refresh') {
    handleClickRefresh()
  } else {
    handleClickBack()
  }
}

const handleClickRefresh = () => {
  location.reload()
}

const handleClickBack = () => {
  router.back()
}

const handleClickMoveHome = () => {
  navigateTo(URL_MAP.HOME)
}
</script>

<template>
  <div class="BaseError">
    <BaseEmptyStates
      :title="title"
      :description="computedDescription"
      class="w-[328px]"
    >
      <template #buttons>
        <slot name="buttons">
          <BaseButtonRectangle
            :title="'홈으로'"
            size="large"
            blocked
            @click="handleClickMoveHome"
          />
          <BaseButtonRectangleTertiary
            :title="buttonTitle"
            size="large"
            blocked
            class="mt-[8px]"
            @click="handleClickSubButton"
          />
        </slot>
      </template>
    </BaseEmptyStates>
  </div>
</template>

<style scoped lang="scss">
.BaseError {
  @apply min-h-[600px];
  @apply flex flex-col justify-center items-center;
}
</style>
